<template>
  <div class="container">
    <!-- <div class="order box">
      <div class="title">
        <span>订单信息</span>
      </div>
      <div class="info-box">
        <div class="row">
          <span>状态：</span>
          <span>{{info.status | status}}</span>
        </div>
        <div class="row">
          <span>类型：</span>
          <span>{{info.type | type}}</span>
        </div>
        <div class="row">
          <span>订单编号：</span>
          <span>{{info.orderNum}}</span>
        </div>
        <div class="row">
          <span>拜访人：</span>
          <span>{{info.name}}</span>
        </div>
        <div class="row">
          <span>手机号码：</span>
          <span>{{info.mobile}}</span>
        </div>
      </div>
    </div>
    <div class="visit box">
      <div class="title">
        <span>受访信息：</span>
      </div>
      <div class="info-box">
        <div class="row">
          <span>拜访时间：</span>
          <span>{{info.reservationDate}}</span>
        </div>
        <div class="row">
          <span>拜访企业：</span>
          <span>{{info.enterpriseName}}</span>
        </div>
      </div>
    </div> -->
    <Box
      :boxTitle='boxTitle[0]'>
      <div class="info-row" slot="info">
        <div class="row">
          <span>状态：</span>
          <span>{{info.status | status}}</span>
        </div>
        <div class="row">
          <span>类型：</span>
          <span>{{info.type | type}}</span>
        </div>
        <div class="row">
          <span>拜访人：</span>
          <span>{{info.name}}</span>
        </div>
        <div class="row">
          <span>手机号码：</span>
          <span>{{info.mobile}}</span>
        </div>
        <div class="row">
          <span>所属产业：</span>
          <span>{{info.industryName}}</span>
        </div>
        <div class="row">
          <span>拜访企业：</span>
          <span>{{info.enterpriseName}}</span>
        </div>
        <div class="row">
          <span>拜访时间：</span>
          <span>{{info.reservationDate}}</span>
        </div>
        <!-- <div class="row">
          <span>订单编号：</span>
          <span>{{info.orderNum}}</span>
        </div> -->
      </div>
    </Box>
    <!-- <Box
      :boxTitle='boxTitle[1]'
      :noMargin='true'>
      <div class="info-row" slot="info">
        <div class="row">
          <span>拜访时间：</span>
          <span>{{info.reservationDate}}</span>
        </div>
        <div class="row">
          <span>拜访企业：</span>
          <span>{{info.enterpriseName}}</span>
        </div>
      </div>
    </Box> -->
  </div>
</template>

<script>
import { getVisitorDetails } from '@/api/company'
import Box from '@/components/box'
export default {
  name: 'VisitDetails',
  data() {
    return {
      info: [],
      body: {
        uuid: ''
      },
      boxTitle: ['订单信息', '受访信息']
    }
  },
  filters: {
    status: function(val) {
      if (val === 0) {
        return '未完成'
      } else if (val === 1) {
        return '已完成'
      } else if(val === 2){
        return '已取消'
      } else if(val === 3){
        return '待审核'
      } else if(val === 4){
        return '已拒绝'
      }
    },
    type: function(val) {
      if (val === 0) {
        return '临时访客'
      } else return '企业访客'
    }
  },
  mounted() {
    this.body.uuid = this.$route.query.uuid
    this.network().getVisitorDetails()
  },
  methods: {
    event() {},
    network() {
      return {
        getVisitorDetails: async() => {
          const { data } = await getVisitorDetails(this.body.uuid)
          this.info = data
        }
      }
    }
  },
  components: {
    Box
  }
}
</script>

<style scoped lang="scss">
.container1{
  height: 100%;
  background-color: #f5f5f5;
  .box{
    margin-bottom: 15px;
    background: #ffffff;
    padding: 15px 30px;
    border-radius: 5px;
    .title{
      font-weight: bold;
      margin-bottom: 30px;
    }
    .row{
      margin-bottom: 30px;
      display: flex;
      span{
        color: grey;
        &:nth-child(1){
          flex: 1;
        }
        &:nth-child(2){
          flex: 9;
        }
      }
    }
  }
}
</style>
